import t from "../../theme";

export const useGetSignInFormStyles = () => {
  return {
    container: {
      width: "92%",
      maxWidth: 420,
      display: "flex",
      flexDirection: "column",
      gap: 18,
      position: "relative",
      zIndex: 1,
      alignItems: "center",
    },
    card: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: 16,
      padding: "22px 20px",
      borderRadius: "22px",
      background: "transparent",
      border: "none",
      boxShadow: "none",
      color: t.brand.white,
    },
    heading: {
      margin: 0,
      fontSize: "26px",
      lineHeight: 1.2,
      fontWeight: 700,
      textAlign: "center",
      color: t.brand.white,
    },
    googleButton: {
      minHeight: 46,
      borderRadius: 999,
      padding: "10px 16px",
      backgroundColor: "rgba(255,255,255,0.18)",
      color: t.brand.white,
      fontWeight: 600,
      fontSize: "14px",
      textTransform: "none",
      boxShadow: "none",
      "&:hover": {
        backgroundColor: "rgba(255,255,255,0.24)",
        boxShadow: "none",
      },
      "&.Mui-disabled": {
        opacity: 0.7,
        color: "rgba(255,255,255,0.8)",
      },
    },
    providerIcon: {
      width: 18,
      height: 18,
      display: "block",
    },
    divider: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      gap: 12,
      color: "rgba(255,255,255,0.7)",
      fontSize: 13,
      "&::before, &::after": {
        content: '""',
        flex: 1,
        height: 1,
        backgroundColor: "rgba(255,255,255,0.18)",
      },
    },
    dividerText: {
      whiteSpace: "nowrap",
    },
    formContainer: {
      display: "flex",
      flexDirection: "column",
      gap: 14,
      width: "100%",
    },
    verificationPanel: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: 14,
    },
    verificationHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12,
      padding: "10px 12px",
      borderRadius: "16px",
      background: "rgba(255,255,255,0.12)",
      border: "1px solid rgba(255,255,255,0.16)",
    },
    emailPill: {
      minWidth: 0,
      fontSize: "15px",
      fontWeight: 600,
      color: t.brand.white,
      overflowWrap: "anywhere",
    },
    changeEmailButton: {
      border: "none",
      background: "transparent",
      color: "#d8f3dc",
      fontSize: "14px",
      fontWeight: 700,
      textDecoration: "underline",
      textUnderlineOffset: "3px",
      cursor: "pointer",
      padding: 0,
      flexShrink: 0,
    },
    verificationCopy: {
      display: "flex",
      flexDirection: "column",
      gap: 6,
      alignItems: "center",
    },
    verificationTitle: {
      margin: 0,
      fontSize: "24px",
      lineHeight: 1.25,
      textAlign: "center",
      color: t.brand.white,
    },
    otpFieldsWrapper: {
      display: "grid",
      gridTemplateColumns: "repeat(6, minmax(0, 1fr))",
      gap: 10,
      width: "100%",
      "@media (max-width: 420px)": {
        gap: 8,
      },
    },
    otpField: {
      width: "100%",
      aspectRatio: "1 / 1",
      borderRadius: "14px",
      border: "1px solid rgba(255,255,255,0.28)",
      background: "rgba(255,255,255,0.94)",
      color: "#184d2f",
      fontSize: "28px",
      fontWeight: 700,
      textAlign: "center",
      outline: "none",
      boxShadow: "0 12px 24px rgba(5, 35, 16, 0.12)",
      transition: "transform 0.16s ease, box-shadow 0.16s ease",
      "&:focus": {
        transform: "translateY(-1px)",
        boxShadow: "0 0 0 3px rgba(146, 214, 161, 0.34)",
      },
    },
    successBox: {
      padding: "14px 16px",
      borderRadius: "14px",
      background: "rgba(224, 244, 228, 0.96)",
      color: "#157347",
      textAlign: "center",
      fontSize: "15px",
      fontWeight: 700,
      lineHeight: 1.5,
    },
    verificationActions: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      gap: 12,
      flexWrap: "wrap",
    },
    resendLink: {
      border: "none",
      background: "transparent",
      color: "#d8f3dc",
      fontSize: "14px",
      fontWeight: 700,
      textDecoration: "underline",
      textUnderlineOffset: "3px",
      cursor: "pointer",
      padding: 0,
      "&:disabled": {
        cursor: "not-allowed",
        opacity: 0.7,
      },
    },
    submitButton: {
      borderRadius: 999,
      minHeight: 46,
      fontWeight: 600,
      fontSize: 15,
      marginTop: 4,
    },
    errorBox: {
      width: "100%",
      borderRadius: 12,
      padding: "10px 12px",
      backgroundColor: "rgba(255, 94, 94, 0.18)",
      border: "1px solid rgba(255, 122, 122, 0.26)",
      color: "#FFE2E2",
      fontSize: 13,
      lineHeight: 1.4,
    },
    termsCopy: {
      margin: 0,
      fontSize: 13,
      lineHeight: 1.6,
      color: "rgba(255,255,255,0.78)",
      textAlign: "center",
    },
    inlineLink: {
      color: t.brand.white,
      textDecoration: "underline",
    },
    signupButton: {
      marginTop: 4,
      color: t.brand.white,
      textTransform: "none",
      fontWeight: 600,
    },
  };
};
